export default __webpack_public_path__ + "static/media/grafema_packaging-cale-do-oiro_07.59984dc1.jpg";